import { Component, HostBinding, Inject, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatInput } from '@angular/material';
import { OwnerByEnum } from '../../../services/eleview/types/model';
export interface DialogData {
	name: string;
	title: string;
}
@Component({
	selector: 'common-edit-category-dialog',
	templateUrl: './edit-category-dialog.component.html',
	styleUrls: ['./edit-category-dialog.component.scss']
})
export class EditCategoryDialogComponent implements OnInit {
	@HostBinding('class.edit-category-dialog') hostClass = true;
	constructor(
		public dialogRef: MatDialogRef<EditCategoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {}

	ngOnInit() {}

	cancel() {
		this.dialogRef.close();
	}
}
